export default "__VITE_ASSET__BXzeVT9K__"